angular.module('impactx.complaintconfiguration').controller('ComplaintConfigurationListCtrl', [
    'selectedListItems',
    ComplaintConfigurationListCtrl
]);

function ComplaintConfigurationListCtrl(selectedListItems) {
    var buttonDefinition = [
        {
            label: "details",
            linkFunction: getDetailLink,
            type: 'link',
            condition: selectedListItems.isSingleSelection,
            process: 'ComplaintConfiguration'
        }
    ];

    this.meta = {
        buttonDefinition: buttonDefinition,
        rowTemplate: 'modules/complaintconfiguration/templates/complaintconfigurationlist.row.tmpl.html',
        isSelectAble: true,
        endpoint: '/complaintconfiguration/list',
        ctrl: this,
        id: "complaintconfigurationlist",
        mainAction: {id: "new", link: "#/complaintconfiguration/new/0", icon: "mdi-plus"},
        excelExport: true
    };

    this.getMeta = function () {
        return this.meta;
    };

    function getDetailLink() {
        return "complaintconfiguration/" + selectedListItems.getFirstSelectedId();
    }
}